import type { DeploymentLineLegalNotice } from "le-coffre-resources/dist/deploymentLineLegalPublisher";

import { LegalNoticeLine, LegalNoticeSectionTitle } from "./LegalNoticePrimitives";

type LegalNoticeHosterProps = {
	notice: DeploymentLineLegalNotice;
};

/** Hébergeur 4NK : nom public uniquement, coordonnées « sur demande » (pas d’adresse ni d’infra). */
export function LegalNoticeHoster(props: LegalNoticeHosterProps): React.JSX.Element {
	const { notice } = props;
	return (
		<>
			<LegalNoticeSectionTitle>03 Hébergeur</LegalNoticeSectionTitle>
			<LegalNoticeLine>{notice.hosterName}</LegalNoticeLine>
			<LegalNoticeLine>Coordonnées : {notice.hosterDetailsLabel}</LegalNoticeLine>
		</>
	);
}
